<template>
  <div class="lh-homes imgs" style="background-image:url(img/bg.png?a=1)">
  	<div style="display:none;">
  		<img src="img/bg.png?a=1">
  		<img src="img/a2.png">
  		<img src="img/figure1.png">
  		<img src="img/figure.png">
  		<img src="img/a3.png">
  	</div>
  	<div class="lh-pro-bg imgs" style="background-image:url(img/bg1.png)"></div>
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：安全文化</span></div>
    <div class="lh-renwu" :class="this.$store.state.home.renwuClass" :style="'transform: translate('+(web?this.$store.state.home.zdata[this.$store.state.home.num].web.x:this.$store.state.home.zdata[this.$store.state.home.num].position.x)+','+(web?this.$store.state.home.zdata[this.$store.state.home.num].web.y:this.$store.state.home.zdata[this.$store.state.home.num].position.y)+')'">
    	<div class="icon" :style="'background-image:url('+this.$store.state.home.img+')'"></div>
    </div>
    <ul class="lh-create-item">
    	<li v-for="(item,idx) in this.$store.state.home.zdata" :class="[item.hover,item.end]" :data-idx="idx" @click="setCreate($event)"><img :src="item.icon" /></li>
    </ul>
    <div class="lh-product-title">
    	<p class="jt"><i></i></p>
    	<h3>{{this.$store.state.home.title}}</h3>
    	<p class="jt jt1"><i></i></p>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>
<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:1,type:'culture'},
      web:''
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
      if(width<=980){
          that.web=true;
      }
  },
	components:{
		Footer
	},
	methods:{
		setCreate(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.$store.commit("setCreate",{idx:idx,$router:that.$router,name:'home'});
		}
	}
}
</script>
